module.exports = __webpack_public_path__ + "static/media/stars.974c448c.svg";